import React from 'react';
import { HardHat, Cross, Factory } from 'lucide-react';
import helmet from '../assets/helmet.png'
import pharmacy from '../assets/pharmacy.png'
import factory from '../assets/factory.png'

const CONTENT = {
  en: {
    heading: "Commercial Cleaning Pros:",
    headingSpan: "Reach New Markets",
    markets: [
      { title: "Construction Leads", description: "Target verified contacts looking for contractors or cleaning crews on job sites, renovations, or commercial builds." },
      { title: "Medical Office", description: "Connect with medical offices, and facilities most in need of deep cleaning and disinfection services." },
      { title: "Industrial Cleaning", description: "Identify factory managers and facility directors responsible for keeping heavy-duty sites spotless." },
    ],
  },
  es: {
    heading: "Profesionales de limpieza comercial:",
    headingSpan: "Alcanza nuevos mercados",
    markets: [
      { title: "Leads de construcción", description: "Dirígete a contactos verificados que buscan contratistas o equipos de limpieza en obras, renovaciones o construcciones comerciales." },
      { title: "Oficinas médicas", description: "Conecta con consultorios médicos e instalaciones que más necesitan limpieza profunda y servicios de desinfección." },
      { title: "Limpieza industrial", description: "Identifica a gerentes de fábricas y directores de instalaciones responsables de mantener sitios de trabajo pesado impecables." },
    ],
  },
};

const ReachMarkets = ({ lang = "en" }) => {
  const t = CONTENT[lang] || CONTENT.en;
  const markets = [
    { icon: helmet, ...t.markets[0] },
    { icon: pharmacy, ...t.markets[1] },
    { icon: factory, ...t.markets[2] },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl font-bold text-[#1465B7] mb-4">
            {t.heading} <span className='text-[#26A94A]'>{t.headingSpan}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          {markets.map((market, index) => (
            <div key={index} className="bg-[#E4F6F9] py-5 px-3 rounded-3xl text-center hover:shadow-lg transition-shadow border-3 border-[#1465B7]">
              <div className={`${market.icon=== helmet ? 'w-40 h-40' : 'w-32 h-32 mb-8'} rounded-full flex items-center justify-center mx-auto min-h-26`}>
                {/* <market.icon className="w-8 h-8 text-green-600" /> */}
                <img src={market.icon} width={300}/>
              </div>
              <h3 className="text-xl font-bold text-[#1465B7] mb-4">
                {market.title}
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed">
                {market.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReachMarkets;